import React, {FC} from "react"
import {HorizontalTextAlign, VerticalTextAlign} from "@dv5/domain"
import "./TextAlignmentPicker.less"

interface Props {
    horizontalAlign: HorizontalTextAlign | null
    verticalAlign: VerticalTextAlign | null
    onHorizontalAlignChange: (align: HorizontalTextAlign) => void
    onVerticalAlignChange: (align: VerticalTextAlign) => void
}

export const TextAlignmentPicker: FC<Props> = ({
                                                   horizontalAlign,
                                                   verticalAlign,
                                                   onHorizontalAlignChange,
                                                   onVerticalAlignChange,
                                               }) => {
    const changeHorizontal = (event: React.MouseEvent<HTMLButtonElement>, align: HorizontalTextAlign) => {
        event.preventDefault()
        event.stopPropagation()
        onHorizontalAlignChange(align)
    }
    const changeVertical = (event: React.MouseEvent<HTMLButtonElement>, align: VerticalTextAlign) => {
        event.preventDefault()
        event.stopPropagation()
        onVerticalAlignChange(align)
    }
    return (
        <div className="text-alignment-picker">
            <div className="text-alignment-picker__row">
                <span className="text-alignment-picker__label">H</span>
                {Object.values(HorizontalTextAlign).map((align) => (
                    <button
                        key={align}
                        className={`text-alignment-picker__button ${horizontalAlign === align ? "text-alignment-picker__button--active" : ""}`}
                        onMouseDown={event => changeHorizontal(event, align)}
                        aria-label={`Horizontal ${align.toLowerCase()}`}
                        type="button"
                    >
                        {align === HorizontalTextAlign.LEFT && "←"}
                        {align === HorizontalTextAlign.CENTER && "↔"}
                        {align === HorizontalTextAlign.RIGHT && "→"}
                    </button>
                ))}
            </div>
            <div className="text-alignment-picker__row">
                <span className="text-alignment-picker__label">V</span>
                {Object.values(VerticalTextAlign).map((align) => (
                    <button
                        key={align}
                        className={`text-alignment-picker__button ${verticalAlign === align ? "text-alignment-picker__button--active" : ""}`}
                        onMouseDown={event => changeVertical(event, align)}
                        aria-label={`Vertical ${align.toLowerCase()}`}
                        type="button"
                    >
                        {align === VerticalTextAlign.TOP && "↑"}
                        {align === VerticalTextAlign.CENTER && "↕"}
                        {align === VerticalTextAlign.BOTTOM && "↓"}
                    </button>
                ))}
            </div>
        </div>
    )
}
